import type { Brouillon, MotifDeCopie } from './poste.js';
import { empreinteDeTexte } from './poste.js';

/**
 * CE QU'ON FAIT D'UN BROUILLON A L'OUVERTURE, pure (`tests/sauvegarde-reprise.test.mjs`).
 *
 * TROIS ISSUES, ET AUCUNE NE JETTE UN TRAVAIL EN SILENCE :
 *
 *  - `rien` : pas de brouillon, ou il ne dit rien de plus que la base (meme
 *    texte au meme format). Il s'oublie ;
 *  - `reprendre` : il est EN AVANCE sur la base (fabrique sur la revision
 *    qu'elle porte encore, ou sur l'ecriture qui etait en vol quand la page est
 *    partie, cf. `brouillonEnAvance`) et le contenu s'ecrit. On part de lui, et
 *    on l'ecrit aussitot, en le disant ;
 *  - `mettre-de-cote` : il ne peut pas s'ecrire EN PLACE. Soit il est en
 *    RETARD (quelqu'un a enregistre depuis : `conflit`), soit le contenu ne
 *    s'ecrit plus (archive, droits). Il devient une COPIE DE SECOURS, et
 *    l'ecran l'annonce. C'etait le cas que la PR 212 jetait.
 */
export type IssueDeReprise =
  | { issue: 'rien' }
  | { issue: 'reprendre'; brouillon: Brouillon }
  | { issue: 'mettre-de-cote'; brouillon: Brouillon; motif: MotifDeCopie };

/** Ce que la base porte a l'ouverture. */
export interface BaseALOuverture {
  version: number;
  formatVersion: number;
  /** Le texte decode tel que la base le porte (avant migration). */
  texte: string;
}

/**
 * LE BROUILLON EST-IL EN AVANCE SUR LA BASE ? Il l'est s'il a ete fabrique sur
 * la revision qu'elle porte (ou une plus recente), OU si la base porte
 * exactement l'ecriture qui etait en vol quand il a ete pose (meme revision,
 * meme empreinte) : « modifier puis rafraichir » tombe souvent pendant une
 * ecriture, et le serveur la recoit quand meme. Sans cette exception, les
 * gestes faits pendant le vol passaient pour un retard.
 */
export function brouillonEnAvance(brouillon: Brouillon, base: BaseALOuverture): boolean {
  if (brouillon.versionBase >= base.version) return true;
  const enVol = brouillon.enVol;
  return enVol !== undefined && enVol.version === base.version && enVol.empreinte === empreinteDeTexte(base.texte);
}

/**
 * @param ecriture - ce qui empeche d'ecrire en place, ou `null` si rien :
 *   `archive` (contenu archive), `droits` (la porte n'ouvre pas l'ecriture).
 */
export function decisionDeReprise(
  brouillon: Brouillon | null,
  base: BaseALOuverture,
  ecriture: 'archive' | 'droits' | null,
): IssueDeReprise {
  if (brouillon === null) return { issue: 'rien' };
  if (brouillon.texte === base.texte && brouillon.formatVersion === base.formatVersion) return { issue: 'rien' };
  if (!brouillonEnAvance(brouillon, base)) return { issue: 'mettre-de-cote', brouillon, motif: 'conflit' };
  if (ecriture !== null) return { issue: 'mettre-de-cote', brouillon, motif: ecriture };
  return { issue: 'reprendre', brouillon };
}
